import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

export interface DdcTabChip {
  key: string
  label: string
  icon: string
  selected: boolean
}

@Component({
  selector: 'ddc-tabs-chips',
  templateUrl: './ddc-tabs-chips.component.html',
  styleUrls: ['./ddc-tabs-chips.component.scss'],
  imports: [CommonModule],
})
export class DdcTabsChipsComponent {
  @Input() tabs: DdcTabChip[] = []
  @Input() theme: 'light' | 'dark' | 'paper' = 'light'
  @Output() tabClick = new EventEmitter<string>()

  getThemeClass(): { [klass: string]: boolean } {
    return {
      'ddc-tabs-scroll-row-light': this.theme === 'light',
      'ddc-tabs-scroll-row-dark': this.theme === 'dark',
      'ddc-tabs-scroll-row-paper': this.theme === 'paper',
    }
  }

  onTabClick(tab: DdcTabChip): void {
    this.tabClick.emit(tab.key)
  }
}
